import { createButton } from './buttons_utils';
import { createTooltip } from './tooltips_utils';

function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldGet2(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _classPrivateFieldSet2(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const CODE_MARKDOWN_CLASS = 'js-markdown-code';
var _actionButton = /*#__PURE__*/new WeakMap();
var _codeBlock = /*#__PURE__*/new WeakMap();
var _handleClick = /*#__PURE__*/new WeakMap();
class InsertCodeSnippetElement extends HTMLElement {
  constructor(_codeBlock2) {
    super();
    _classPrivateFieldInitSpec(this, _actionButton, void 0);
    _classPrivateFieldInitSpec(this, _codeBlock, void 0);
    _classPrivateFieldInitSpec(this, _handleClick, () => {
      // We fetch the code element on click instead because the structure of the HTML can change after
      // the element is initialized (e.g. on sanitation), and we don't want to use an element that is
      // not present in the DOM.
      const codeElement = this.getCodeElement(_classPrivateFieldGet2(_codeBlock, this));
      if (codeElement) {
        codeElement.dispatchEvent(new CustomEvent('insert-code-snippet', {
          bubbles: true,
          cancelable: true,
          detail: {
            code: codeElement.textContent.trim()
          }
        }));
      }
    });
    _defineProperty(this, "getCodeElement", codeBlock => {
      const wrapper = codeBlock !== null && codeBlock !== void 0 ? codeBlock : this.closest(`.${CODE_MARKDOWN_CLASS}`);
      return wrapper.getElementsByTagName('code')[0] || wrapper.getElementsByTagName('pre')[0];
    });
    this.initialize(_codeBlock2);
  }

  // we handle two possible cases here:
  // 1. we use constructor parameter if the element is created in Javascript and inserted in the document
  // 2. we find the wrapping element containing code if the element is received from the server
  async initialize(codeBlock) {
    if (!this.getCodeElement(codeBlock)) return;
    _classPrivateFieldSet2(_codeBlock, this, codeBlock);
    _classPrivateFieldSet2(_actionButton, this, createButton());
    const tooltip = await createTooltip(_classPrivateFieldGet2(_actionButton, this), 'Insert at cursor');
    this.appendChild(tooltip);
  }
  connectedCallback() {
    if (_classPrivateFieldGet2(_actionButton, this)) {
      this.appendChild(_classPrivateFieldGet2(_actionButton, this));
      _classPrivateFieldGet2(_actionButton, this).addEventListener('click', _classPrivateFieldGet2(_handleClick, this));
    }
  }
  disconnectedCallback() {
    if (_classPrivateFieldGet2(_actionButton, this)) {
      _classPrivateFieldGet2(_actionButton, this).removeEventListener('click', _classPrivateFieldGet2(_handleClick, this));
    }
  }
}

export { InsertCodeSnippetElement };
